
import {
	SET_DATA,
	SET_META,
	ADD_DATA,
	REMOVE_DATA,
	SET_COLUMNS,
	SET_ORIGINAL_COLUMNS,
	SET_SORT_BY,
	SET_FILTERS,
	CLEAR_DATA,
	SET_SELECTED,
	CLEAR_SELECTED,
	SET_SORT_ORDER
} from './mutation-types'
import { mergeColumnSizing } from '@/utils/tableColumns'

export default {
	[SET_DATA] (state, data) {
		state.data = data
	},
	[SET_META] (state, meta) {
		state.meta = meta
	},
	[ADD_DATA] (state, data) {
		state.data = [...state.data, data]
	},
	[REMOVE_DATA] (state, id) {
		state.data = state.data.filter(item => item.id !== id)
	},
	[CLEAR_DATA] (state) {
		state.data = []
	},
	[SET_COLUMNS] (state, columns) {
		state.columns = mergeColumnSizing(columns, state.originalColumns)
	},
	[SET_ORIGINAL_COLUMNS] (state, columns) {
		state.originalColumns = columns
		state.columns = mergeColumnSizing(state.columns, columns)
	},
	[SET_SORT_BY] (state, sortBy) {
		if (state.sortBy === sortBy) {
			if (state.sortOrder === 'desc') {
				state.sortOrder = 'asc'
			} else {
				state.sortOrder = 'desc'
			}
		} else {
			state.sortOrder = 'desc'
		}
		state.sortBy = sortBy
	},
	[SET_SORT_ORDER] (state, order) {
		state.sortOrder = order
	},
	[SET_FILTERS] (state, filters) {
		state.filters = filters
	},
	[SET_SELECTED] (state, selected) {
		state.selected = selected
	},
	[CLEAR_SELECTED] (state) {
		state.selected = []
	}
}
